<template>
  <v-list
    class="pl-0 ml-0"
    style="border-radius: 6px; background: #fff;margin-left: 0px;"
  >
    <v-list-item
      class="graph-list-item"
      style="border-radius: 6px; background: #fff;"
    >
      <!-- Checkbox -->
      <v-list-item-action>
        <v-checkbox
          :inputValue="isGraphChecked"
          :hideDetails="true"
          style="margin: 0; padding: 0;"
          @change="onCheckboxChange"
        />
      </v-list-item-action>

      <!-- Icon -->
      <v-list-item-action>
        <div
          class="icon-border d-flex justify-center align-center"
          style="border: 1px solid #26384B; border-radius: 4px; width: 26px; height: 26px; margin-right: 5px;"
        >
          <v-icon
            dense
            color="#26384B"
          >
            bar_chart
          </v-icon>
        </div>
      </v-list-item-action>

      <!-- Title -->
      <v-list-item-content>
        <v-list-item-title class="graph-title d-flex align-center">
          {{ graphic.name }}
          <v-icon
            class="chevron ml-2"
            color="#26384B"
            style="font-size: 18px; cursor: pointer;"
            @click="handleOpenChildren"
          >
            {{ showDetail ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
          </v-icon>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <div
      v-show="showDetail"
      class="graphic-content-bordered"
    >
      <GraphicContents
        ref="graphicContentsRef"
        :showDetail="showDetail"
        :series="series"
        :seriesData="seriesData"
        :graphic="graphic"
        :showSpinner="showSpinner"
        :workOrderGraph="true"
        @fetchSeries="fetchSeries"
        @updatedOpenedGraphs="updatedOpenedGraphs"
        @getSeriesData="fetchSeriesData"
      />
    </div>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';
import { getSeriesData } from '@/utilities/graphs';
import GraphicContents from './GraphicContents.vue';

export default {
    name: 'WorkOrderGraphic',
    components: {
        GraphicContents,
    },
    props: {
        graphic: {
            type: Object,
            default: () => ({}),
        },
        selectedGraphIds: {
            type: Array,
            default: () => [],
        },
        series: {
            type: Array,
            default: () => [],
        },
        seriesData: {
            type: Array,
            default: () => [],
        },
        showSpinner: {
            type: Boolean,
            default: false,
        },
        showDetail: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['lang', 'teamMainLang', 'getSeries']),
        getTitle() {
            return this.graphic?.name;
        },
        isGraphChecked() {
            return this.selectedGraphIds.includes(this.graphic.id);
        },

    },
    methods: {
        async fetchSeriesData() {
            const { siteId } = this.$route.params;
            this.seriesData = await getSeriesData(this.$rq, siteId, this.graphic.id, this.lang);
        },
        handleOpenChildren() {
            this.$emit('handleOpenChildren');
        },
        onCheckboxChange(checked) {
            this.$emit('onSelect', { graphicId: this.graphic.id, checked });
            if (checked) {
                this.handleOpenChildren();
            }
        },
        fetchSeries() {
            this.$emit('fetchSeries');
        },
        getSeriesData() {
            this.$emit('getSeriesData');
        },
        updatedOpenedGraphs(data) {
            if (this.isGraphChecked) {
                this.$emit('updatedOpenedGraphs', data);
            }
        },

    },
};
</script>

<style scoped>
.graph-list-item {
  transition: background 0.2s;
}
.graph-list-item.selected {
  background: #f5f7fa;
}
.graph-title {
  font-size: 15px;
  font-weight: 500;
  color: #26384B;
}
.chevron:hover {
  color: #1976D2;
}
.graphic-content-bordered {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;
  margin: 16px 0 16px 0; /* border starts under checkbox */
  padding: 16px;
  box-shadow: 0 2px 8px rgba(38,56,75,0.03);
}
</style>
